import React, { useEffect, useRef } from 'react';
import { getFieldValue } from '@sitecore-jss/sitecore-jss-react';
import { Section } from 'components/shared';
import styled from 'styled-components';
import breakpoints from 'utils/breakpoints';
import pageTypes from 'utils/pageTypes';
import { useLocation } from 'react-router-dom';
import { scrollToSection } from 'utils/scrollTo';

import { SectionImage } from 'components/components/organisms';
import { SectionImageCarousel } from 'components/components/organisms';

const StyledSection = styled(Section)`
  & section:first-child {
    margin-top: 0;
  }
  & section:last-child {
    padding-bottom: 1.563rem;
  }
  @media ${breakpoints.lg} {
    & section:first-child {
      margin-top: 3.125rem;
    }
    & section:last-child {
      padding-bottom: 3.125rem !important;
    }
  }
`;

const mapMultiBlocks = (multiBlocks) =>
  multiBlocks
    .map((mB) => ({
      heading: mB.title,
      copy: mB.text,
      image: mB.image,
      ctas: [mB.firstCTA, mB.secondCTA],
      video: mB.displayOption === 'Video' ? mB.video : {},
      transcriptText: mB.videoTrancriptText,
      transcriptFile: mB.videoTranscriptFile,
    }))
    .filter(
      (mB) =>
        mB.image.src ||
        mB.image.srcDesktop ||
        mB.image.srcMobile ||
        (mB.video && mB.video.href),
    );

const MultiBlocks = ({ fields, rendering }) => {
  // Fields
  const multiblocks = getFieldValue(fields, 'multiblocks');
  const currentPageType = getFieldValue(fields, 'currentPageType');

  const multiblockRef = useRef();
  useEffect(() => {
    let current = multiblockRef.current;
    if (current && currentPageType === pageTypes.MarketDesignStudio) {
      current.setAttribute('id', 'appintmentprep');
      current.setAttribute('tabIndex', '-1');
    }
    if (
      current &&
      (currentPageType === pageTypes.CommunityPage ||
        currentPageType === pageTypes.CondoPage)
    ) {
      current.setAttribute('id', 'features');
      current.setAttribute('tabIndex', '-1');
    }
  }, []);

  const location = useLocation();
  const hash = location.hash;
  useEffect(() => {
    if (hash && hash.substring(1) === 'features') {
      setTimeout(() => {
        scrollToSection(hash.substring(1), 80);
      }, 1500);
    }
  });

  if (multiblocks.length === 0) {
    return null;
  }
  return (
    <StyledSection noPaddingMobile ref={multiblockRef}>
      {multiblocks.map((mB, index) => {
        if (Array.isArray(mB.multiBlocks)) {
          const multiBlocksArray = mB.multiBlocks || [];
          if (multiBlocksArray.length > 1) {
            const mappedCarousel = mapMultiBlocks(multiBlocksArray);
            // console.log(mB.textStyle);
            return (
              <SectionImageCarousel
                key={index}
                carousel={mappedCarousel}
                alignment={mB.imageAlignment}
                cutOffTitle={false}
                textStyle={mB.textStyle}
              />
            );
          } else {
            const multiBlock = multiBlocksArray[0];
            // console.log(mB.textStyle);
            return (
              multiBlock && (
                <SectionImage
                  key={multiBlock.title}
                  heading={multiBlock.title}
                  copy={multiBlock.text}
                  image={multiBlock.image}
                  ctas={[multiBlock.firstCTA, multiBlock.secondCTA]}
                  alignment={mB.imageAlignment}
                  textStyle={mB.textStyle}
                  cutOffTitle={false}
                  video={multiBlock.video}
                  type={multiBlock.type}
                  transcriptFile={multiBlock.videoTranscriptFile}
                  transcriptText={multiBlock.videoTrancriptText}
                />
              )
            );
          }
        }
      })}
    </StyledSection>
  );
};

export default MultiBlocks;
